/** Exponential backoff with full jitter, capped. Pure for testability. */
export function backoffDelay(
  attempt: number,
  opts: { baseMs?: number; maxMs?: number; random?: () => number } = {},
): number {
  const base = opts.baseMs ?? 1000;
  const max = opts.maxMs ?? 30_000;
  const rnd = opts.random ?? Math.random;
  const exp = Math.min(max, base * 2 ** Math.max(0, attempt));
  return Math.floor(rnd() * exp);
}
